import React, { useEffect, useMemo, useState } from 'react';
import Swal from 'sweetalert2';
import '../../../Pages/Css/solicitudes.css';
import axios from '../../../utils/axiosConfig';
import { Col, Row } from 'reactstrap';
import ModalBaseSm from '../../modals/modal-base-sm';
import FormModalCreateAcompanante from '../forms/formModalCreateAcompanante';

const ModalAcompanantes = ({ bitInserts, bitEdits, bitDeletes }) => {
    const [cc, setCc] = useState('');
    const [nombre, setNombre] = useState('');
    const [telefono, setTelefono] = useState('');
    const [acompanantes, setAcompanantes] = useState([]);
    const [idEdit, setIdEdit] = useState(-1);

    const [dialogOpen, setDialogOpen] = useState(false);

    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedTerm, setDebouncedTerm] = useState(searchTerm);

    const filtered = useMemo(() => {
        if (!debouncedTerm) return acompanantes;
        return acompanantes.filter(item =>
            Object.values(item).some(val =>
                String(val || '')
                    .toLowerCase()
                    .includes(debouncedTerm)
            )
        );
    }, [acompanantes, debouncedTerm]);

    useEffect(() => {
        const handler = setTimeout(
            () => setDebouncedTerm(searchTerm.trim().toLowerCase()),
            300
        );
        return () => clearTimeout(handler);
    }, [searchTerm]);

    useEffect(() => {
        listarAcompanantes();
    }, []);

    const listarAcompanantes = () => {
        axios
            .post(
                process.env.REACT_APP_SERVER + '/operaciones2/getacompanantes',
                {},
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('tkn')}`,
                    },
                    withCredentials: true,
                }
            )
            .then(res => {
                if (res.data.success) {
                    console.log(
                        'Acompañantes cargados:',
                        res.data.data.recordset
                    );
                    setAcompanantes(res.data.data.recordset);
                } else
                    Swal.fire(
                        'Error',
                        'No se pudo cargar acompañantes',
                        'error'
                    );
            })
            .catch(() =>
                Swal.fire(
                    'Error',
                    'Falla de red al cargar lista',
                    'error'
                )
            );
    };

    const guardar = ({ nombre, cc, telefono }) => {
        if (!cc.trim() || !nombre.trim() || !telefono.trim()) {
            Swal.fire(
                'Error',
                'Debe completar CC, Nombre y Teléfono',
                'error'
            );
            return;
        }
        const payload = {
            NoDocumento: cc,
            Nombre: nombre,
            Telefono: telefono,
            ID: -1,
        };
        console.log('Payload a subir para crear:', payload);
        axios
            .post(
                process.env.REACT_APP_SERVER + '/operaciones2/setacompanantes',
                JSON.stringify(payload),
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('tkn')}`,
                    },
                    withCredentials: true,
                }
            )
            .then(res => {
                if (!res.data.success) {
                    Swal.fire('Error', 'No se pudo guardar', 'error');
                    return;
                }
                console.log(
                    'Acompañante guardado respuesta:',
                    res.data
                );
                Swal.fire(
                    'Éxito',
                    'Acompañante guardado',
                    'success'
                );
                listarAcompanantes();
                limpiarCampos();
                toggleDialog();
            })
            .catch(() =>
                Swal.fire('Error', 'No se pudo guardar', 'error')
            );
    };

    const update = ({ nombre, cc, telefono }) => {
        if (!cc.trim() || !nombre.trim() || !telefono.trim()) {
            Swal.fire(
                'Error',
                'Debe completar CC, Nombre y Teléfono',
                'error'
            );
            return;
        }
        const payload = {
            NoDocumento: cc,
            Nombre: nombre,
            Telefono: telefono,
            ID: idEdit,
        };
        console.log('Payload a subir para actualizar:', payload);
        axios
            .post(
                process.env.REACT_APP_SERVER + '/operaciones2/setacompanantes',
                JSON.stringify(payload),
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('tkn')}`,
                    },
                    withCredentials: true,
                }
            )
            .then(res => {
                if (!res.data.success) {
                    Swal.fire(
                        'Error',
                        'No se pudo actualizar',
                        'error'
                    );
                    return;
                }
                console.log(
                    'Acompañante actualizado respuesta:',
                    res.data
                );
                Swal.fire(
                    'Éxito',
                    'Acompañante actualizado',
                    'success'
                );
                listarAcompanantes();
                limpiarCampos();
                toggleDialog();
            })
            .catch(() =>
                Swal.fire(
                    'Error',
                    'No se pudo actualizar',
                    'error'
                )
            );
    };

    const handleInsertOrUpdateAcompanante = ({
        nombre,
        cc,
        telefono,
    }) => {
        if (!nombre.trim() || !cc.trim() || !telefono.trim()) {
            Swal.fire(
                'Error',
                'Debe completar todos los campos: Nombre, Identificación y Teléfono',
                'error'
            );
            return;
        }
        if (idEdit === -1) {
            guardar({ nombre, cc, telefono });
        } else {
            update({ nombre, cc, telefono });
        }
    };

    const toggleDialog = () => {
        setDialogOpen(o => !o);
        if (dialogOpen) {
            setNombre('');
            setCc('');
            setTelefono('');
            setIdEdit(-1);
        }
    };

    const editarAcompanante = item => {
        console.log('Editando acompañante:', item);
        setCc(item.NoDocumento);
        setNombre(item.Nombre);
        setTelefono(item.Telefono);
        setIdEdit(item.IDAcompaniante);
        setDialogOpen(true);
    };

    const borrarAcompanante = item => {
        Swal.fire({
            title: '¿Está seguro?',
            text: `Está a punto de eliminar el acompañante "${item.NoDocumento}". Esta acción no se puede deshacer.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#d33',
            cancelButtonColor: '#006699',
        }).then(result => {
            if (result.isConfirmed) {
                axios
                    .post(
                        process.env.REACT_APP_SERVER +
                        `/operaciones2/deleteacompanantes`,
                        JSON.stringify({
                            ID: item.IDAcompaniante,
                        }),
                        {
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem(
                                    'tkn'
                                )}`,
                            },
                            withCredentials: true,
                        }
                    )
                    .then(() => {
                        Swal.fire(
                            'Eliminado',
                            'El acompañante ha sido eliminado.',
                            'success'
                        );
                        listarAcompanantes();
                    });
            }
        });
    };

    const limpiarCampos = () => {
        setCc('');
        setNombre('');
        setTelefono('');
        setIdEdit(-1);
    };

    return (
        <>
            {/* Estilos responsivos solo para este componente */}
            <style>
                {`
                    @media (max-width: 575.98px) {
                        .btn-nuevo-acompanante {
                            width: 100%;
                        }
                    }
                `}
            </style>

            <Row className="mb-4 align-items-center">
                <Col sm="6">
                    <input
                        type="text"
                        className="form-input w-100"
                        placeholder="Buscar acompañante..."
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                        style={{ height: '38px', boxSizing: 'border-box' }}
                    />
                </Col>
                <Col
                    sm="6"
                    className="d-flex justify-content-center justify-content-sm-end mt-2 mt-sm-0"
                >
                    <button
                        className="Button blue btn-nuevo-acompanante"
                        onClick={() => {
                            if (bitInserts) toggleDialog();
                        }}
                        style={{ height: '38px', minWidth: '150px' }}
                    >
                        Nuevo Acompañante
                    </button>
                </Col>
            </Row>

            <div className="card ContainerTableMaestros">
                <div
                    className="table-responsive text-nowrap"
                    style={{ height: '300px', overflowY: 'auto' }}
                >
                    <table
                        className="table table-hover"
                        id="tabla"
                        style={{ width: '100%', overflowX: 'auto' }}
                    >
                        <thead className="FondoHeaderTabla2">
                            <tr>
                                <th
                                    style={{
                                        color: '#ffffff',
                                        width: '30%',
                                    }}
                                >
                                    Nombre
                                </th>
                                <th
                                    style={{
                                        color: '#ffffff',
                                        width: '20%',
                                        textAlign: 'center',
                                    }}
                                >
                                    Identificación
                                </th>
                                <th
                                    style={{
                                        color: '#ffffff',
                                        width: '20%',
                                        textAlign: 'center',
                                    }}
                                >
                                    Teléfono
                                </th>
                                <th
                                    style={{
                                        color: '#ffffff',
                                        width: '20%',
                                        textAlign: 'center',
                                    }}
                                >
                                    Acciones
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtered.map((item, i) => (
                                <tr key={i}>
                                    <td style={{ color: '#000' }}>
                                        {item.Nombre || '-'}
                                    </td>
                                    <td style={{ color: '#000' }}>
                                        {item.NoDocumento || '-'}
                                    </td>
                                    <td
                                        style={{
                                            color: '#000',
                                            textAlign: 'center',
                                        }}
                                    >
                                        {item.Telefono || '-'}
                                    </td>
                                    <td style={{ textAlign: 'center' }}>
                                        <a
                                            href="#"
                                            onClick={e => {
                                                e.preventDefault();
                                                if (bitEdits)
                                                    editarAcompanante(item);
                                            }}
                                        >
                                            <i
                                                className="bx bxs-pencil bx-tada"
                                                style={{ color: '#006699' }}
                                            />
                                        </a>{' '}
                                        <a
                                            href="#"
                                            onClick={e => {
                                                e.preventDefault();
                                                // borrarAcompanante(item);
                                            }}
                                        >
                                            <i
                                                className="bx bx-trash"
                                                style={{ color: '#006699' }}
                                            />
                                        </a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* MODAL */}
            <ModalBaseSm
                isOpen={dialogOpen}
                title={
                    idEdit === -1
                        ? 'Crear Acompañante'
                        : 'Editar Acompañante'
                }
                onClose={toggleDialog}
                childComponent={
                    <FormModalCreateAcompanante
                        onSave={handleInsertOrUpdateAcompanante}
                        initialData={{ nombre, cc, telefono }}
                    />
                }
            />
        </>
    );
};

export default ModalAcompanantes;
